import actionTypes from 'app/actions/action-types';

export default (state = false, action) => {
  switch (action.type) {
    case actionTypes.FETCH_WIDGETS_SUCCESS:
      return action.draft;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/app/reducers/widgets/draft.js